export default class ProcessadorValorCaixaDeChecagem {
    processar(campo) {
        return campo.opcoes.reduce((acc, opcao) => {
            acc[opcao.nome] = opcao.valor;
            return acc;
        }, {});
    }
}
